import { render, staticRenderFns } from "./vSuministros.vue?vue&type=template&id=1f394dab&scoped=true"
import script from "./vSuministros.vue?vue&type=script&lang=js"
export * from "./vSuministros.vue?vue&type=script&lang=js"
import style0 from "./vSuministros.vue?vue&type=style&index=0&id=1f394dab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f394dab",
  null
  
)

export default component.exports